import { Address } from '../../../models/Address/Address.js';

class AddressBook {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  get(country, city, zipCode) {
    return this.apiClient.get('/pro/user/destination-addresses', {
      country,
      city,
      postal_code: zipCode
    }).then(_ref => {
      let {
        data
      } = _ref;
      return data.map(address => Address.createFromResponse({
        ...address,
        street1: address.address,
        street2: null,
        zip_code: address.postal_code
      }));
    });
  }
  post(address) {
    const {
      street1,
      zip_code,
      ...payload
    } = address.getCreatePayload();
    return this.apiClient.post('/pro/user/destination-addresses', {
      ...payload,
      address: street1,
      postal_code: zip_code
    }).then(_ref2 => {
      let {
        data
      } = _ref2;
      return Address.createFromResponse({
        ...data,
        street1: data.address,
        street2: null,
        zip_code: data.postal_code
      });
    });
  }
  put(address) {
    const {
      street1,
      zip_code,
      ...payload
    } = address.getUpdatePayload();
    return this.apiClient.put('/pro/user/destination-addresses', {
      ...payload,
      address: street1,
      postal_code: zip_code
    }).then(_ref3 => {
      let {
        data
      } = _ref3;
      return Address.createFromResponse({
        ...data,
        street1: data.address,
        street2: null,
        zip_code: data.postal_code
      });
    });
  }
}

export { AddressBook };
//# sourceMappingURL=AddressBook.js.map
